import { RestService, Rest } from "@abp/ng.core";
import { Injectable } from "@angular/core";
import { ProfileInfo, ProfileInformation } from "../model/profile.model";
import { UserTimeZoneDto } from "../model/UserTimeZoneDto.model";
import { DropDownDto } from "projects/crm-services/src/lib/proxy/coredata-service/verified-from-emails";



@Injectable({
    providedIn: 'root'
})
export class ProfileService {
    apiName = 'AbpAccountPublic';

    constructor(private readonly restService: RestService) { }

    getProfileImage = (id: any) =>
        this.restService.request<any, ''>(
            {
                method: 'GET',
                url: `/api/account/profile-picture/${id}`,
            },
            { apiName: this.apiName }
        );


    updateProfileImage = (type: any, data: File) =>
        this.restService.request<any, boolean>(
            {
                method: 'POST',
                url: `/api/account/profile-picture`,
                body: this.updateImage(type, data),
            },
            { apiName: this.apiName }
        );

    updateImage(type, data) {
        const formData = new FormData();
        if (type == 0) {
            formData.append('type', type);
        } else if (type == 1) {
            formData.append('type', type);
        } else if (data != null) {
            formData.append('type', type);
            formData.append('ImageContent', data[0]);
        }

        return formData;
    }
    getProfileInfo = () =>
        this.restService.request<any, ProfileInfo>({
            method: 'GET',
            url: '/api/account/my-profile',
        }, { apiName: 'AbpAccountPublic' });

    postProfileInfo = (input: ProfileInformation) =>
        this.restService.request<any, ProfileInformation>({
            method: 'PUT',
            url: '/api/identity-server/custom-profile/custom-profile',
            body: input,
        });
    timeZoneList = () =>
        this.restService.request<any, ProfileInfo>({
            method: 'GET',
            url: '/api/setting-management/GetTimeZones',
        });

    postTimeZone = (input: UserTimeZoneDto) =>
        this.restService.request<any, Response>({
            method: 'POST',
            url: '/api/setting-management/UserTimeZoneSetting',
            body: input,
        });

    getUserTimeZone = () =>
        this.restService.request<any, UserTimeZoneDto>({
            method: 'GET',
            url: '/api/setting-management/GetUserTimeZoneSetting',
        });

    updatePassword = (input: any) =>
        this.restService.request<any, any>({
            method: 'POST',
            url: '/api/account/my-profile/change-password',
            body: input,
        },
            { apiName: this.apiName }
        );

    getMFA = () =>
        this.restService.request<any, any>({
            method: 'GET',
            url: 'api/account/my-profile/two-factor-enabled',
        }, { apiName: this.apiName });

    setMFA = (input: any) =>
        this.restService.request<any, any>({
            method: 'POST',
            url: `api/account/my-profile/set-two-factor-enabled?enabled=${input}`,
        }, { apiName: this.apiName });


    getAuthenticationCode = () =>
        this.restService.request<any, any>({
            method: 'GET',
            url: 'api/account/authenticator-info',
        }, { apiName: this.apiName });

    verifyCode = (input: any) =>
        this.restService.request<any, any>({
            method: 'POST',
            url: 'api/account/verify-authenticator-code',
            body: input,
        }, { apiName: this.apiName });

    hasAuthentication = () =>
        this.restService.request<any, any>({
            method: 'GET',
            url: 'api/account/has-authenticator-key',
        }, { apiName: this.apiName });

    resetAuthenticator = () =>
        this.restService.request<any, any>({
            method: 'POST',
            url: 'api/account/reset-authenticator',
        }, { apiName: this.apiName });

    insertAgencyProfile = (input: any, data: File) =>
        this.restService.request<any, boolean>(
            {
                method: 'POST',
                url: '/api/coredata-service/agency-profile-configuration',

                body: this.generateAgencyProfile(data, input),
            },
            { apiName: 'Default' }
        )
    private generateAgencyProfile(data, input: any) {
        const formData = new FormData();
        if (!input.logoFile) {
            formData.append('iFileProvider', null);
            formData.append('uniqueURLCode', '' + input.uniqueURLCode);
            formData.append('displayName', '' + input.displayName);
        } else {
            formData.append('logoFile', input.logoFile, input.logoFile.name);
            formData.append('uniqueURLCode', '' + input.uniqueURLCode);
            formData.append('displayName', '' + input.displayName);
        }
        return formData;
    }

    getAgencyProfile = () =>
        this.restService.request<any, any>({
            method: 'GET',
            url: '/api/coredata-service/agency-profile-configuration/profile',
        }, { apiName: 'Default' });


    getTopNotification = (config?: Partial<Rest.Config>) =>
        this.restService.request<any, any[]>({
            method: 'GET',
            url: '/api/coredata-service/notification/top-notification',
        },
            { apiName: 'Default', ...config });

    dropDown = (config?: Partial<Rest.Config>) =>
        this.restService.request<any, DropDownDto[]>({
            method: 'POST',
            url: '/api/coredata-service/verified-from-emails/drop-down',
        },
            { apiName: 'Default', ...config });

}